module.exports = __webpack_public_path__ + "static/media/img_howto_web_illust2@2x.ce8a23ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_howto_web_illust2@2x.png
// module id = 1078
// module chunks = 0